<div id="leader_talk_wrap">
    <div id="picture" class="pic_{{learningPathMetaId}}">

    </div>
    <div id="talk" class="talk_item" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" >
        {{talk}}
    </div>
</div>
<div id="test">萨科技打卡时间来得快上得快</div>



// WEBPACK FOOTER //
// ./src/app/leader-talk/leader-talk.component.html